import Vue from 'vue';
import Vuex from 'vuex';
import UserStore from './modules/User.store';
import FormStore from './modules/Form.store';
import CompanyStore from './modules/Company.store';
import LicenseStore from './modules/License.store';
import EventStore from './modules/Event.store';
import DateStore from './modules/Date.store';

Vue.use(Vuex);

export default new Vuex.Store({
  modules:{
    UserStore,
    FormStore,
    CompanyStore,
    LicenseStore,
    EventStore,
    DateStore
 }
});



// WEBPACK FOOTER //
// ./src/store/index.js